import React from 'react';

export const IconSmallSettingsLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M10 4h4l.307 2.46c.48.2.929.46 1.336.772l2.285-.964 2 3.464-1.977 1.497a6.057 6.057 0 010 1.542l1.977 1.497-2 3.464-2.285-.964a5.989 5.989 0 01-1.336.772L14 20h-4l-.307-2.46c-.48-.2-.929-.46-1.336-.772l-2.285.964-2-3.464 1.977-1.497a6.057 6.057 0 010-1.542L4.072 9.732l2-3.464 2.285.964a5.994 5.994 0 011.336-.772L10 4zm2 11a3 3 0 100-6 3 3 0 000 6z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
